// src/sessionKonto.js
import { reactive } from 'vue';

export default reactive({
  value: 0 // Startwert bei jedem Reload
});
